<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content parent-box">
      <div class="box-request">
        <p style="text-align: left; padding: 15px;" v-if="!authType">
          連携なしでカレンダーの利用を開始します。
        </p>
        <p style="text-align: left; padding: 15px;" v-if="authType === 'nolinkage'">
          利用を終了するとカレンダーのデータはすべて削除されます。
        </p>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button
        @click="saveNoLinkage()"
        class="button is-primary"
        v-if="!authType"
        >
        利用を開始する
      </button>
      <button class="button is-danger" v-if="authType === 'nolinkage'" @click="deleteNoLinkage()">利用を終了する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    },
    authType: {
      type: String,
      require: true
    },
    user: {
      type: Object,
      require: true
    },
    saveNoLinkage: {
      type: Function,
      require: true
    },
    deleteNoLinkage: {
      type: Function,
      require: true
    }
  },
  data () {
    return {
      title: '連携なしでカレンダーを利用する'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.setting-card {
  height: 100px;
  width: 280px;
  border-radius: 8px;
  border: solid thin #ccc;
  margin: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-weight: 600;
    color: #C82E42;
    margin-bottom: 8px;
  }
  .input-box {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin-left: 8px;
    }
    select {
      max-width: 200px;
    }
  }
}
.action-box {
  width: calc(100% - 32px);
  height: 48px;
  display: flex;
  align-items: center;
  margin-left: 16px;
  p {
    margin-left: 16px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalNoLinkage.vue